export function initPopup() {
  const popupTriggers = document.querySelectorAll('.js-popup_trigger');
  if (!popupTriggers.length) return;

  popupTriggers.forEach((popupTrigger) => {
    if (popupTrigger.__initialized) return;

    popupTrigger.__initialized = true;

    popupTrigger.addEventListener('click', (e) => {
      const popupId = popupTrigger.dataset.popupId;
      if (!popupId) return;

      const popup = document.getElementById(popupId);
      if (!popupId) return;

      let restoreImage = null;

      // ---- HANDLE IMAGE POPUP ----
      if (popupTrigger.classList.contains('img-popup')) {
        e.preventDefault();
        restoreImage = handleImagePopup(popupTrigger, popup);
      }

      // ---- SET DYNAMIC CONTENT ----
      const isDynamicData = popupTrigger.dataset.dynamicData;

      if (isDynamicData) {
        const popupTitleDataElement = popupTrigger.querySelectorAll('.js-dialog_title');
        const popupContentDataElement = popupTrigger.querySelectorAll('.js-dialog_content');

        if (popupTitleDataElement || popupContentDataElement) {
          setDynamicData(popupTitleDataElement, popupContentDataElement, popup);
        }
      }

      open(popup);

      // ---- CLOSE HANDLERS ----
      const closePopupBtn = popup.querySelectorAll('.js-close_popup')[0];

      // close popup on close button click
      closePopupBtn &&
        closePopupBtn.addEventListener('click', () => {
          close(popup);
        });

      // close popup on overlay click
      popup.addEventListener('click', (event) => {
        if (popupId === 'image-with-zoom_popup') {
          if (event.target !== event.target.closest('.img-full-popup_img')) {
            close(popup);
            if (restoreImage) restoreImage();
            return;
          }
        }

        if (event.target === event.currentTarget) {
          close(popup);
        }
      });
    });
  });
}

function setDynamicData(title, content, popup) {
  const popupTitle = popup.querySelectorAll('.js-dialog_title');
  const popupContent = popup.querySelectorAll('.js-dialog_content');

  if (popupTitle && title) {
    popupTitle[0].innerHTML = title[0].innerHTML;
  }

  if (popupContent && content) {
    popupContent[0].innerHTML = content[0].innerHTML;
  }
}

function handleImagePopup(trigger, popup) {
  const imgFull = popup.querySelector('.img-full-popup_img');
  if (!imgFull) return;

  const prevSrc = imgFull.src;
  imgFull.src = trigger.href;

  return () => {
    setTimeout(() => {
      imgFull.src = prevSrc;
    }, 300); // wait for popup close animation
  };
}

function open(popup) {
  document.body.classList.add('popup-open');
  popup.classList.add('m-active');
}

function close(popup) {
  document.body.classList.remove('popup-open');
  popup.classList.remove('m-active');
}
